import React, { useEffect, useState } from 'react';
import './Registry.css';

export default function Registry() {
  const [artists, setArtists] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('/api/registry')
      .then((r) => r.json())
      .then((data) => {
        if (data.success) setArtists(data.artists || []);
        else setError(data.message || 'Failed to load registry');
      })
      .catch((err) => {
        console.error('Error fetching registry:', err);
        setError('Failed to load registry');
      })
      .finally(() => setLoading(false));
  }, []);

  function viewEpk(artist) {
    const identifier = artist.slug || artist.username || artist.id;
    window.location.href = `/epk/${identifier}`;
  }

  if (loading) {
    return (
      <div className="registry-loading">
        <div className="registry-spinner" />
        <p>Loading registry…</p>
      </div>
    );
  }

  return (
    <div className="registry-view">
      <div className="registry-header">
        <h1>Artist Registry</h1>
        <p>Meet our community of artists and creators</p>
      </div>

      {error && <div className="registry-error">{error}</div>}

      {artists.length === 0 ? (
        <div className="registry-empty">
          <div className="registry-empty-icon">👥</div>
          <p>No artists in the registry yet</p>
        </div>
      ) : (
        <div className="registry-grid">
          {artists.map((artist, i) => {
            const name = artist.artistname || `${artist.firstname || ''} ${artist.lastname || ''}`.trim();
            return (
              <div className="registry-card" key={artist.id || i}>
                <div className="registry-card-photo" onClick={() => viewEpk(artist)}>
                  {artist.photo ? (
                    <img src={artist.photo} alt={name} />
                  ) : (
                    <div className="registry-card-avatar">
                      {artist.firstname?.[0]}{artist.lastname?.[0]}
                    </div>
                  )}
                  <span className="registry-card-badge">EPK</span>
                </div>
                <div className="registry-card-body">
                  <h2 onClick={() => viewEpk(artist)}>{name}</h2>
                  {artist.username && <div className="registry-card-username">@{artist.username}</div>}
                  {artist.bio && (
                    <p className="registry-card-bio">
                      {artist.bio.length > 150 ? `${artist.bio.substring(0, 130)}…` : artist.bio}
                    </p>
                  )}
                  <button className="mihu-btn-primary-lg registry-card-cta" onClick={() => viewEpk(artist)}>
                    View EPK
                  </button>
                  {artist.email && (
                    <a className="registry-card-email" href={`mailto:${artist.email}`}>{artist.email}</a>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
